import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { BaseSharedModule } from '../../../../../../../_base-shared/base-shared.module';
import { AppSelectOption } from '../../../../../../../_base-shared/contracts/common.interface';
import { SystemConfigurationService } from './system-configuration.service';

@Component({
  standalone:  true,
  imports:     [BaseSharedModule],
  selector:    'app-general-system-configuration-config',
  templateUrl: './general-system-configuration.component.html',
  styles:      [],
})
export class GeneralSystemConfigurationComponent implements OnInit {
  public form: UntypedFormGroup;
  public formReady    = false;
  public isSubmitting = 0;
  public amountPaid: Array<AppSelectOption> = [
    {label: '250', value: '250'},
    {label: '375', value: '375'},
    {label: '500', value: '500'},
    {label: '750', value: '750'},
  ];

  constructor(private fb: UntypedFormBuilder,
              private configService: SystemConfigurationService,
              private toast: ToastrService,
              public translate: TranslateService) {
  }

  ngOnInit(): void {
    this.configService.getConfigData().subscribe(next => this.buildForm(next.data));
  }

  public submit(): void {
    this.isSubmitting++;
    this.configService.index(this.form.value)
      .pipe(finalize(() => this.isSubmitting--))
      .subscribe({
        next:  () => this.toast.success(this.translate.instant('CONFIG.system-event.config-saved')),
        error: () => this.toast.error(this.translate.instant('CONFIG.system-event.config-saved-error')),
      });
  }

  private buildForm(data): void {
    const aprRate                       = data.find(obj => obj.key === 'apr_rate');
    const debtReductionFee              = data.find(obj => obj.key === 'debt_reduction_fee');
    const percentageReductionBad        = data.find(obj => obj.key === 'percentage_reduction_bad');
    const percentageReductionDecent     = data.find(obj => obj.key === 'percentage_reduction_decent');
    const percentageReductionGood       = data.find(obj => obj.key === 'percentage_reduction_good');
    const fixedDistributionFee          = data.find(obj => obj.key === 'fixed_distribution_fee');
    const percentageDistributionFee     = data.find(obj => obj.key === 'percentage_distribution_fee');
    const mandatesAmountPaid            = data.find(obj => obj.key === 'mandates_amount_paid_threshold');
    const minimumOfferToCreditors       = data.find(obj => obj.key === 'minimum_offer_to_creditors');
    const maximumPercentageOffer        = data.find(obj => obj.key === 'maximum_percentage_offer_to_creditors');
    const negotiationFeePercentage      = data.find(obj => obj.key === 'negotiation_fee_percentage');
    const defaultIvaRate                = data.find(obj => obj.key === 'default_iva_rate');
    const dsReductionPercent            = data.find(obj => obj.key === 'ds_reduction_percent');
    const dsDefaultFeeAmount            = data.find(obj => obj.key === 'ds_default_fee_amount');
    const dsDefaultFdsReduction         = data.find(obj => obj.key === 'ds_default_fds_reduction');
    const lockoutDefaultPercentage      = data.find(obj => obj.key === 'lockout_default_percentage');
    const defaultMonthlyTerm            = data.find(obj => obj.key === 'default_monthly_term');

    this.form = this.fb.group({
      apr_rate:                              aprRate ? aprRate.value : '',
      debt_reduction_fee:                    debtReductionFee ? debtReductionFee.value : '',
      percentage_reduction_bad:              percentageReductionBad ? percentageReductionBad.value : '',
      percentage_reduction_decent:           percentageReductionDecent ? percentageReductionDecent.value : '',
      percentage_reduction_good:             percentageReductionGood ? percentageReductionGood.value : '',
      fixed_distribution_fee:                fixedDistributionFee ? fixedDistributionFee.value : '',
      percentage_distribution_fee:           percentageDistributionFee ? percentageDistributionFee.value : '',
      mandates_amount_paid_threshold:        mandatesAmountPaid ? mandatesAmountPaid.value : '',
      minimum_offer_to_creditors:            minimumOfferToCreditors ? minimumOfferToCreditors.value : '',
      maximum_percentage_offer_to_creditors: maximumPercentageOffer ? maximumPercentageOffer.value : '',
      negotiation_fee_percentage:            negotiationFeePercentage ? negotiationFeePercentage.value : '',
      ds_reduction_percent:                  dsReductionPercent ? dsReductionPercent.value : '',
      ds_default_fee_amount:                 dsDefaultFeeAmount ? dsDefaultFeeAmount.value : '',
      ds_default_fds_reduction:              dsDefaultFdsReduction ? dsDefaultFdsReduction.value : '',
      default_iva_rate:                      defaultIvaRate ? defaultIvaRate.value : '',
      lockout_default_percentage: [
        lockoutDefaultPercentage ? lockoutDefaultPercentage.value : '',
        [Validators.required, Validators.min(1), Validators.max(100)],
      ],
      default_monthly_term: [
        defaultMonthlyTerm ? defaultMonthlyTerm.value : '',
        [Validators.required, Validators.min(1)],
      ],
    });

    this.formReady = true;
  }
}
